import { isMobile } from 'react-device-detect';

const IframeBridge = (function () {
  /**
   * postMessage로 전송할 기본 데이터 폼
   */
  function createSendData() {
    return {
      command: '', // 처리 동작 command
      data: undefined, // 동작 처리 시 필요한 정보 (object)
    };
  }

  return {
    /**
     * 창 닫기 메시지 전송
     */

    sendViewOff: function (obj) {
      // 전송할 데이터 생성 및 처리 동작 command 지정
      let response = undefined;
      if (obj !== undefined) {
        response = {
          redirect: obj.returnUrl,
          data: obj,
        };
      }

      const data = createSendData();
      data.command = window.PayverseCommand.VIEW_OFF;
      if (response !== undefined) {
        data.data = response;
      }

      // 데이터 전송
      window.parent.postMessage(data, '*');
    },
    sendShopifyViewOff: function (obj) {
      const data = createSendData();
      data.command = window.PayverseCommand.SHOPIFY_VIEW_OFF;
      if (obj !== undefined) {
        data.data = obj;
      }

      // 데이터 전송
      window.parent.postMessage(data, '*');
    },
  };
})();

export default IframeBridge;
